// extracted by mini-css-extract-plugin
export default {"backButton":"BatchRunBreadCrumb_backButton__72xJv","label":"BatchRunBreadCrumb_label__xAIV4","text":"BatchRunBreadCrumb_text__zp42J"};